import { BaseService } from '../../infra/base.service'
import type { CashierEntity } from './cashier.entity'
import type { CashiersRepository } from './cashiers.repository'

export class CashiersService extends BaseService<CashierEntity> {
    constructor(private rep: CashiersRepository) {
        super(rep)
    }

    async reopen(cashierId: string) {
        return await this.rep.reopen(cashierId)
    }

    async close(cashierId: string, cashClose: number, cashResult: number, cashIn: number, cashOut: number, result: any[], notes?: string) {
        return await this.rep.close(cashierId, cashClose, cashResult, cashIn, cashOut, result, notes)
    }

    async opened() {
        return await this.rep.opened()
    }
}
